module.exports = "/_next/static/images/2a1374bf01a1d75cb363af8b321b05c7-bill_empty_package.png.webp";